<template>
  <div id="contenedor-expedientes-catalogo-documentos-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ExpedientesCatalogoDocumentosMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
